module.exports = __webpack_public_path__ + "static/media/background5.bb19f880.jpg";